import React, { useState, useEffect, useContext, useCallback, memo } from 'react';
import axios from '../../utils/axios';
import { LanguageContext } from '../../context/LanguageContext';
import './ItemList.css';

const ItemCard = memo(({ item, onClick, isRTL }) => {
  const price = parseFloat(item.price);
  const style = item.color ? { 
    background: `linear-gradient(135deg, ${item.color}, ${adjustColor(item.color, -20)})`,
    color: '#fff',
    border: 'none'
  } : {};

  // Helper function to darken/lighten color
  function adjustColor(color, amount) {
    const hex = color.replace('#', '');
    const num = parseInt(hex, 16);
    const r = Math.min(255, Math.max(0, (num >> 16) + amount));
    const b = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amount));
    const g = Math.min(255, Math.max(0, (num & 0x0000ff) + amount));
    return `#${(g | (b << 8) | (r << 16)).toString(16).padStart(6, '0')}`;
  }

  return (
    <div
      className="item-card menu-item"
      onClick={onClick}
      role="button"
      tabIndex={0}
      style={style}
    >
      <div className="item-name">
        {isRTL ? item.name_ar : item.name}
      </div>
      <div className="item-price">
        {price.toFixed(2)} {isRTL ? 'ريال' : 'SAR'}
      </div>
    </div>
  );
});

const ItemList = ({ selectedCategory, onItemClick }) => {
  const { language } = useContext(LanguageContext);
  const isRTL = language === 'ar';
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        setLoading(true);
        setError(null);
        const url = selectedCategory ? `/items?category_id=${selectedCategory}` : '/items';
        const response = await axios.get(url);
        setItems(response.data.data?.filter(item => item.is_active) || []);
      } catch (err) {
        console.error('Error loading menu items:', err);
        setError(language === 'ar' 
          ? 'حدث خطأ أثناء تحميل قائمة الطعام' 
          : 'Error loading menu items');
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [selectedCategory, language]);

  const handleItemClick = useCallback((item, e) => {
    e.stopPropagation();
    onItemClick(item);
  }, [onItemClick]);

  if (loading) return <div className="loading-state">{language === 'ar' ? 'جاري التحميل...' : 'Loading...'}</div>;
  if (error) return <div className="error-state">{error}</div>;
  if (!items.length) return <div className="empty-state">{language === 'ar' ? 'لا توجد منتجات' : 'No items available'}</div>;

  return (
    <div className="item-list">
      <div className={`items-grid ${isRTL ? 'rtl' : ''}`}>
        {items.map(item => (
          <ItemCard
            key={item.id}
            item={item}
            onClick={(e) => handleItemClick(item, e)}
            isRTL={isRTL}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(ItemList);
